// extracted by mini-css-extract-plugin
export var layoutContainer = "_46-0";
export var layoutContainerOpen = "_46-5";
export var layoutContainerResizing = "_46-1";
export var mainContent = "_46-2";
export var resizeDivider = "_46-3";
export var slidePanel = "_46-4";